/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import PassageSequencingQuestionVo from './PassageSequencingQuestionVo';




  /**
   * The PassageSequencingDrillVo model module.
   * @module drill/model/PassageSequencingDrillVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>PassageSequencingDrillVo</code>.
   * @alias module:drill/model/PassageSequencingDrillVo
   * @class
   * @param subType {Integer} 子类型 暂时固定为 801 听力理解排序题
   * @param text {String} 文本
   * @param questionList {Array.<module:drill/model/PassageSequencingQuestionVo>} 排序题列表
   */
  var exports = function(subType, text, questionList) {
    var _this = this;


    _this['subType'] = subType;

    _this['text'] = text;








    _this['questionList'] = questionList;
  };

  /**
   * Constructs a <code>PassageSequencingDrillVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/PassageSequencingDrillVo} obj Optional instance to populate.
   * @return {module:drill/model/PassageSequencingDrillVo} The populated <code>PassageSequencingDrillVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'subType')) {
        obj['subType'] = ApiClient.convertToType(data['subType'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'required')) {
        obj['required'] = ApiClient.convertToType(data['required'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'text')) {
        obj['text'] = ApiClient.convertToType(data['text'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'explanation')) {
        obj['explanation'] = ApiClient.convertToType(data['explanation'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'imageUrl')) {
        obj['imageUrl'] = ApiClient.convertToType(data['imageUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'audioUrl')) {
        obj['audioUrl'] = ApiClient.convertToType(data['audioUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'videoUrl')) {
        obj['videoUrl'] = ApiClient.convertToType(data['videoUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'imageUri')) {
        obj['imageUri'] = ApiClient.convertToType(data['imageUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'audioUri')) {
        obj['audioUri'] = ApiClient.convertToType(data['audioUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'videoUri')) {
        obj['videoUri'] = ApiClient.convertToType(data['videoUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'correctAnswer')) {
        obj['correctAnswer'] = ApiClient.convertToType(data['correctAnswer'], [['String']]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'questionList')) {
        obj['questionList'] = ApiClient.convertToType(data['questionList'], [PassageSequencingQuestionVo]);
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 子类型 暂时固定为 801 听力理解排序题
   * @member {Integer} subType
   */
  exports.prototype['subType'] = undefined;
  /**
   * 必做
   * @member {Boolean} required
   */
  exports.prototype['required'] = undefined;
  /**
   * 文本
   * @member {String} text
   */
  exports.prototype['text'] = undefined;
  /**
   * 解析
   * @member {String} explanation
   */
  exports.prototype['explanation'] = undefined;
  /**
   * 图片地址
   * @member {String} imageUrl
   */
  exports.prototype['imageUrl'] = undefined;
  /**
   * 音频url
   * @member {String} audioUrl
   */
  exports.prototype['audioUrl'] = undefined;
  /**
   * 视频url
   * @member {String} videoUrl
   */
  exports.prototype['videoUrl'] = undefined;
  /**
   * 图片地址
   * @member {String} imageUri
   */
  exports.prototype['imageUri'] = undefined;
  /**
   * 音频
   * @member {String} audioUri
   */
  exports.prototype['audioUri'] = undefined;
  /**
   * 视频
   * @member {String} videoUri
   */
  exports.prototype['videoUri'] = undefined;
  /**
   * 正确答案，二维数组，每个子数组对应一个排序题的正确答案
   * @member {Array.<Array.<String>>} correctAnswer
   */
  exports.prototype['correctAnswer'] = undefined;
  /**
   * 排序题列表
   * @member {Array.<module:drill/model/PassageSequencingQuestionVo>} questionList
   */
  exports.prototype['questionList'] = undefined;



  export default exports;
;


